import { MAPPING_MACHINE_HEALTH_TEXT } from 'util/config/constant';
import { formatDate } from 'util/date';
import { getMachineType } from 'util/machine-type';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';

const columnWidth = '20%';

export const renderColumns = ({ t }) => [
  {
    width: columnWidth,
    title: t('overviewStatusTable.columns.machine'),
    render: (_, machine) => {
      const { alias, materialNumber } = machine;
      return (
        <div aria-hidden="true">
          {getMachineType(materialNumber)} <br />
          {alias}
        </div>
      );
    }
  },
  {
    width: columnWidth,
    title: t('overviewStatusTable.columns.materialSerialNumber'),
    render: (_, machine) => {
      const { materialNumber, serialNumber } = machine;
      return (
        <div>
          {materialNumber} <br />
          {serialNumber}
        </div>
      );
    }
  },
  {
    width: columnWidth,
    title: t('overviewStatusTable.columns.machineHealth'),
    dataIndex: 'health',
    render: (health) => {
      return MAPPING_MACHINE_HEALTH_TEXT[health];
    }
  },
  {
    width: columnWidth,
    title: t('overviewStatusTable.columns.lastConnection'),
    dataIndex: 'lastConnectedAt',
    render: (lastConnectedAt) => {
      return formatDate(lastConnectedAt);
    }
  },
  {
    width: columnWidth,
    title: t('overviewStatusTable.columns.lastNotification'),
    dataIndex: 'lastNotificationMessage',
    render: (lastNotificationMessage) => {
      return (
        lastNotificationMessage &&
        t(`${lastNotificationMessage}.description`, {
          ns: TRANSLATION_NAMESPACES.NOTIFICATION_CODES
        })
      );
    }
  }
];
